import { ConciergeBehaviorSettingsParser } from "@redotech/redo-model/concierge-settings/general";
import { object, string } from "zod/v4";
import { UrlArraySchema } from "../common/url-parser";

export const generateConciergeBehavior = {
  name: "generateConciergeBehavior" as const,
  input: object({ text: string().max(100_000), urls: UrlArraySchema }),
  output: ConciergeBehaviorSettingsParser,
};
